/**
 * Centralized environment configuration.
 *
 * All process.env reads happen here — the rest of the app
 * imports from this module instead of touching process.env directly.
 *
 * CRA injects REACT_APP_* vars at build time, so these are
 * compile-time constants (safe to import anywhere).
 */

// ── Helpers ──────────────────────────────────────────────────

const env = (key: string, fallback = ''): string => process.env[key] ?? fallback;

const requireEnv = (key: string): string => {
  const value = process.env[key];
  if (!value) {
    console.warn(`[config] Missing required env var: ${key}. ` + `Check .env.development or Amplify console.`);
  }
  return value ?? '';
};

// ── Exported config ──────────────────────────────────────────

/** AWS Cognito user pool */
export const COGNITO_USER_POOL_ID = requireEnv('REACT_APP_COGNITO_USER_POOL_ID');
export const COGNITO_CLIENT_ID = requireEnv('REACT_APP_COGNITO_CLIENT_ID');

/** API Gateway — Lambda proxy base URL (no trailing slash) */
export const API_URL = env('REACT_APP_API_URL').replace(/\/+$/, '');

/** Alpaca OAuth */
export const ALPACA_CLIENT_ID = env('REACT_APP_ALPACA_CLIENT_ID');
export const ALPACA_REDIRECT_URI = env('REACT_APP_ALPACA_REDIRECT_URI');

/** Sentry error tracking */
export const SENTRY_DSN = env('REACT_APP_SENTRY_DSN');

/** WebSocket — real-time push notifications */
export const WS_URL = env('REACT_APP_WS_URL');

/** Convenience flags */
export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_PROD = process.env.NODE_ENV === 'production';
